/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CloudFileService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create cloud file. Accepts form-data with the file. Returns a link to the file
     * @returns any
     * @throws ApiError
     */
    public upload(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/cloud-file',
        });
    }

    /**
     * List cloud files
     * @returns string
     * @throws ApiError
     */
    public list(): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/cloud-file',
        });
    }

    /**
     * Delete cloud file
     * @param filename
     * @returns any
     * @throws ApiError
     */
    public delete(
        filename: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/cloud-file/{filename}',
            path: {
                'filename': filename,
            },
        });
    }

}
